import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search, AlertTriangle } from 'lucide-react';
import ParticleBackground from '../components/ParticleBackground';
import AnimatedBackground from '../components/AnimatedBackground';
import GlowingCard from '../components/GlowingCard';

export default function NotFoundPage() {
  return (
    <div className="relative min-h-screen pt-20 flex items-center justify-center">
      <AnimatedBackground variant="cyber" />
      <ParticleBackground density={20} />

      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <GlowingCard glowColor="purple">
          <div className="p-12">
            {/* Glitch Effect 404 */}
            <div className="relative mb-8">
              <h1 className="text-8xl lg:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400">
                404
              </h1>
              <div className="absolute inset-0 text-8xl lg:text-9xl font-bold text-blue-500/20 transform translate-x-1 translate-y-1">
                404
              </div>
            </div>

            <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mx-auto mb-6">
              <AlertTriangle className="w-8 h-8 text-amber-400" />
            </div>

            <h2 className="text-2xl lg:text-3xl font-bold text-white mb-4">
              Page Not Found
            </h2>

            <p className="text-slate-400 mb-8 max-w-md mx-auto">
              The page you're looking for doesn't exist or has been moved.
              Let's get you back on track.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white transition-all"
              >
                <Home className="w-5 h-5" />
                Go Home
              </Link>

              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold border border-slate-700 hover:border-blue-500/50 text-slate-300 hover:text-white transition-all"
              >
                <ArrowLeft className="w-5 h-5" />
                Go Back
              </button>
            </div>
          </div>
        </GlowingCard>

        {/* Helpful links */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { name: 'Features', href: '/features' },
            { name: 'Documentation', href: '/docs' },
            { name: 'Contact', href: '/contact' },
          ].map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="px-4 py-3 rounded-lg bg-slate-800/50 border border-slate-700/50 text-slate-400 hover:text-white hover:border-blue-500/50 transition-all text-sm"
            >
              {link.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
